{
    "coordinates": [
        57.32148692092076,
        -2.8456429889866968
    ],
    "tooltip": "Rhynie Chert",
    "title": "Rhynie Chert",
    "country": "UK",
    "period": "Devonian",
    "alt": "TODO"
}
